"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const SvgSeeds = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 4C3.862 4 2 5.502 2 7.5S3.862 11 6 11s4-1.502 4-3.5S8.138 4 6 4m0 1.5c1.452 0 2.5.96 2.5 2s-1.048 2-2.5 2-2.5-.96-2.5-2 1.048-2 2.5-2m11.427.74c-.835.014-1.637.314-2.255.932-1.413 1.413-1.158 3.79.353 5.303 1.512 1.511 3.89 1.766 5.303.353s1.158-3.79-.353-5.303c-.85-.85-1.975-1.303-3.048-1.285m.287 1.508c.575.052 1.187.325 1.7.838 1.027 1.027 1.089 2.446.354 3.182-.736.735-2.155.673-3.182-.354s-1.089-2.446-.354-3.182c.368-.367.907-.536 1.482-.484m-9.649 4.163c-1.372.014-2.643.688-3.21 1.94-.823 1.82.254 3.956 2.202 4.838a4.4 4.4 0 0 0 2.363.363C10.09 20.244 11.46 21 13 21c2.138 0 4-1.502 4-3.5S15.138 14 13 14c-.363 0-.713.047-1.05.127a4.37 4.37 0 0 0-2.008-1.817 4.5 4.5 0 0 0-1.877-.399m-.191 1.504c.454-.04.954.038 1.45.263 1.323.598 1.882 1.905 1.453 2.852-.428.948-1.778 1.39-3.101.791s-1.883-1.905-1.454-2.852c.268-.592.896-.987 1.652-1.054M13 15.5c1.452 0 2.5.96 2.5 2s-1.048 2-2.5 2c-.918 0-1.683-.406-2.113-.95a3.15 3.15 0 0 0 1.258-1.402c.233-.516.309-1.057.26-1.588q.285-.059.595-.06"
  }));
};
var _default = exports.default = SvgSeeds;